<template>
  <section id="blog" class="n2-seccion n4-blog" v-if="B?.Mostrar && articulos.length">
    <div class="n2-contenedor">
      <div class="n4-cabeza n4-cabeza--fila n2-aparece">
        <span class="n4-cabeza__num" aria-hidden="true">{{ numero('blog') }}</span>
        <h2 class="n4-titular" v-html="B.Titulo?.Texto || tituloSeccion(NOTARIA, 'Blog', $t)"></h2>
        <NuxtLink v-if="NOTARIA.Theme.Menu?.ShowBlog" :to="getLocalePath('/blog')" class="n2-enlace">{{ tSolicitud('Ver todos') }} <span aria-hidden="true">→</span></NuxtLink>
        <div v-if="B.Descripcion?.Texto" class="n2-entradilla" :style="alineacionTexto(B.Descripcion.css)" v-html="B.Descripcion.Texto"></div>
      </div>

      <!-- Noticia principal grande y el resto en columna, separadas por filetes -->
      <div class="n4-blog__rejilla" :class="{ 'n4-blog__rejilla--uno': articulos.length === 1 }">
        <NuxtLink :to="getLocalePath('/blog/' + principal.Slug)" class="n4-blog__principal n2-aparece">
          <img :src="imagenIDtoSRC(principal.Imagen)" :alt="principal.Titulo" loading="lazy" />
          <time v-if="fechaNotin(principal.Fecha)">{{ formatoFecha(principal.Fecha) }}</time>
          <h3>{{ principal.Titulo }}</h3>
          <p>{{ textoPlano(principal.Extracto || principal.Contenido, 220) }}</p>
        </NuxtLink>
        <div v-if="resto.length" class="n4-blog__resto">
          <NuxtLink v-for="a in resto" :key="a.id" :to="getLocalePath('/blog/' + a.Slug)" class="n4-blog__item n2-aparece">
            <time v-if="fechaNotin(a.Fecha)">{{ formatoFecha(a.Fecha) }}</time>
            <h3>{{ a.Titulo }}</h3>
            <p>{{ textoPlano(a.Extracto || a.Contenido, 120) }}</p>
          </NuxtLink>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useStore } from '../../store/index'
import { useUtils } from '#imports'
import { t as tSolicitud, idiomaSolicitud } from '../../composables/solicitudTextos'
import { tituloSeccion, textoPlano, fechaNotin, alineacionTexto } from '../../composables/useNotaria2'
import { useSumario } from '../../composables/useNotaria4'

const store = useStore()
const { NOTARIA } = storeToRefs(store)
const { imagenIDtoSRC, $t, getLocalePath } = useUtils()
const { numero } = useSumario()
// Panel: Inicio → Blog, y los artículos publicados con "Mostrar en inicio" e imagen
const B = computed(() => NOTARIA.value?.Theme?.Home?.Blog)
const articulos = computed(() => (NOTARIA.value?.Blog ?? [])
  .filter(a => a.Publicado && a.MostrarHome && a.Imagen)
  .sort((a, b) => fechaNotin(b.Fecha) - fechaNotin(a.Fecha))
  .slice(0, 4))
const principal = computed(() => articulos.value[0])
const resto = computed(() => articulos.value.slice(1))
const formatoFecha = (f) => new Date(fechaNotin(f)).toLocaleDateString(idiomaSolicitud.value, { year: 'numeric', month: 'long', day: 'numeric' })
</script>
